import type { BoxProps } from 'theme-ui';
import { Flex } from 'theme-ui';

import { useMediaQuery } from '../../helpers/mediaQuery';

export const Wrapper = ({ sx, ...rest }: BoxProps) => {
  const isScreenSm = useMediaQuery({ maxWidth: 'sm' });

  return (
    <Flex
      backgroundColor="white"
      paddingBottom={isScreenSm ? 'grid-24' : 'grid-40'}
      paddingTop={isScreenSm ? 'grid-24' : 'grid-36'}
      paddingX={isScreenSm ? 'grid-24' : 'grid-40'}
      sx={{
        flexDirection: 'column',
        maxWidth: '460px',
        ...sx,
      }}
      {...rest}
    />
  );
};
